import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { Label } from "../Typography/Label.js";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
import { Box } from "../Box/Box.js";
import { toViewClass } from "../../utils/toViewClass.js";
import { Icon } from "../Icon/Icon.js";
import { Stack } from "../Stack/Stack.js";
const RepeaterItemContainer = memo(({ actions, children, gap, label, dragHandleComponent: Handle }) => {
  const componentClassName = `${useClassNamePrefix()}repeater-item-container`;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      gap,
      className: classNames(
        componentClassName,
        toViewClass("sortable", !!Handle)
      ),
      children: [
        Handle && /* @__PURE__ */ jsx("div", { className: `${componentClassName}-handle`, children: /* @__PURE__ */ jsx(Handle, { children: /* @__PURE__ */ jsx(Icon, { blueprintIcon: "drag-handle-vertical" }) }) }),
        (label || actions) && /* @__PURE__ */ jsxs("div", { className: `${componentClassName}-header`, children: [
          label && /* @__PURE__ */ jsx("div", { className: `${componentClassName}-label`, children: /* @__PURE__ */ jsx(Label, { children: label }) }),
          actions && /* @__PURE__ */ jsx("div", { className: `${componentClassName}-actions`, children: actions })
        ] }),
        /* @__PURE__ */ jsx(
          Stack,
          {
            className: `${componentClassName}-content`,
            direction: "vertical",
            gap,
            children
          }
        )
      ]
    }
  );
});
RepeaterItemContainer.displayName = "RepeaterItemContainer";
export {
  RepeaterItemContainer
};
//# sourceMappingURL=RepeaterItemContainer.js.map
